document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.main-video.my-swiper');

  sliders.forEach(function (el) {
    var playBtn = el.querySelector('.btn-play');
    var pauseBtn = el.querySelector('.btn-pause');
    var currentEl = el.querySelector('.current');
    var totalEl = el.querySelector('.total');

    // ✅ 실제 슬라이드 수(복제 제외)
    var realCount = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

var main_swiper = new Swiper(el, {
  slidesPerView: 'auto',              // 🔥 1로 고정
  spaceBetween: 20,
  loop:true,

        centeredSlides: true,
 observer: true,
  observeParents: true,

  pagination: {
    el: el.querySelector('.swiper-pagination-banner'),
    type: 'progressbar'
  },

  navigation: {
    nextEl: el.querySelector('.swiper-button-next'),
    prevEl: el.querySelector('.swiper-button-prev')
  },

  autoplay: false,

  on: {
    init() { updateFraction(this); },
    slideChange() { updateFraction(this); }
  }
});

    function updateFraction(sw) {
      if (!currentEl || !totalEl) return;

      var current = sw.realIndex + 1;
      var total = realCount; // ✅ 복제 제외한 실제 개수로 고정

      currentEl.textContent = current < 10 ? '0' + current : current;
      totalEl.textContent = total < 10 ? '0' + total : total;
    }

    if (playBtn) {
      playBtn.type = 'button';
      playBtn.onclick = function (e) {
        e.preventDefault();
        main_swiper.params.autoplay = { delay: 3000, disableOnInteraction: false };
        main_swiper.autoplay.start();
        playBtn.style.display = 'none';
        if (pauseBtn) pauseBtn.style.display = 'inline-block';
      };
    }

    if (pauseBtn) {
      pauseBtn.type = 'button';
      pauseBtn.onclick = function (e) {
        e.preventDefault();
        main_swiper.autoplay.stop();
        pauseBtn.style.display = 'none';
        if (playBtn) playBtn.style.display = 'inline-block';
      };
    }
  });
});

